<h1 mat-dialog-title>Broadcast config</h1>
<div mat-dialog-content>
  <form [formGroup]="formData" (ngSubmit)="update()">
    <mat-tab-group>
      <mat-tab label="Basic config">
        <div class="broadcast-form">
          <mat-checkbox formControlName="manualStatus">Manual status</mat-checkbox>
          <mat-checkbox formControlName="autopilot">Autopilot</mat-checkbox>
          <mat-checkbox formControlName="useManualLineups">Use Manual Lineups</mat-checkbox>
        </div>
        <div class="broadcast-form">
          <mat-form-field class="status-msg-input">
            <mat-label>Game status</mat-label>
            <input matInput formControlName="statusMsg">
          </mat-form-field>
        </div>
        <div class="broadcast-form">
          <mat-form-field class="status-msg-input">
            <mat-label>Big logo</mat-label>
            <input matInput formControlName="bigLogoUrl">
          </mat-form-field>
        </div>
        <div class="broadcast-form">
          <mat-form-field class="status-msg-input">
            <mat-label>Small logo</mat-label>
            <input matInput formControlName="smallLogoUrl">
          </mat-form-field>
        </div>
        <div class="broadcast-form">
          <mat-form-field>
            <mat-label>Background color</mat-label>
            <input type="text" matInput formControlName="backgroundColor">
            <ngx-colors
              class="prefix"
              matPrefix
              ngx-colors-trigger
              formControlName="backgroundColor"
              [hideColorPicker]="false"
              [hideTextInput]="false"
            ></ngx-colors>
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab label="Teams configuration">
        <div class="teams-section">
          <mat-card>
            <mat-card-header>
              <div mat-card-avatar class="team-avatar">
                <img [src]="broadcast.config.awayConfig.logoUrl">
              </div>
              <mat-card-title>Away team</mat-card-title>
            </mat-card-header>
            <mat-card-content class="team-form" formGroupName="awayConfig">
              <mat-form-field>
                <mat-label>Full name</mat-label>
                <input type="text" matInput formControlName="fullName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Away color</mat-label>
                <input type="text" matInput formControlName="primaryColor">
                <ngx-colors
                  class="prefix"
                  matPrefix
                  ngx-colors-trigger
                  [palette]="colorPalette"
                  formControlName="primaryColor"
                  [hideColorPicker]="true"
                  [hideTextInput]="false"
                ></ngx-colors>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Away secondary color</mat-label>
                <input type="text" matInput formControlName="secondaryColor">
                <ngx-colors
                  class="prefix"
                  matPrefix
                  ngx-colors-trigger
                  [palette]="colorPalette"
                  formControlName="secondaryColor"
                  [hideColorPicker]="false"
                  [hideTextInput]="false"
                ></ngx-colors>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Away logo</mat-label>
                <input type="text" matInput formControlName="logoUrl" />
              </mat-form-field>
            </mat-card-content>
          </mat-card>
          <mat-card>
            <mat-card-header>
              <div mat-card-avatar class="team-avatar">
                <img [src]="broadcast.config.homeConfig.logoUrl">
              </div>
              <mat-card-title>Home team</mat-card-title>
            </mat-card-header>
            <mat-card-content class="team-form" formGroupName="homeConfig">
              <mat-form-field>
                <mat-label>Full name</mat-label>
                <input type="text" matInput formControlName="fullName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Home color</mat-label>
                <input type="text" matInput formControlName="primaryColor">
                <ngx-colors
                  class="prefix"
                  matPrefix
                  ngx-colors-trigger
                  [palette]="colorPalette"
                  formControlName="primaryColor"
                  [hideColorPicker]="false"
                  [hideTextInput]="false"
                ></ngx-colors>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Home secondary color</mat-label>
                <input type="text" matInput formControlName="secondaryColor">
                <ngx-colors
                  class="prefix"
                  matPrefix
                  ngx-colors-trigger
                  [palette]="colorPalette"
                  formControlName="secondaryColor"
                  [hideColorPicker]="false"
                  [hideTextInput]="false"
                ></ngx-colors>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Home logo</mat-label>
                <input type="text" matInput formControlName="logoUrl" />
              </mat-form-field>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
      <mat-tab label="Additional">
        <div class="broadcast-form">
            <mat-checkbox formControlName="skipPortraits">Skip portraits</mat-checkbox>
        </div>
        <div class="broadcast-form">
          <mat-label>Speed unites:</mat-label>
          <mat-radio-group aria-label="Select an option" formControlName="unites">
            <mat-radio-button value="MPH">
              MPH
            </mat-radio-button>
            <mat-radio-button value="KMH">
              KMH
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="broadcast-form">
          <mat-checkbox formControlName="lowerRange">Lower range</mat-checkbox>
        </div>
        <div class="broadcast-form">
          <mat-form-field class="status-msg-input">
            <mat-label>Box score time [s]</mat-label>
            <input matInput type="number" formControlName="boxScoreTime">
          </mat-form-field>
          <mat-form-field class="status-msg-input">
            <mat-label>Batter time [s]</mat-label>
            <input type="number" matInput formControlName="batterTime">
          </mat-form-field>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false">
    Close
  </button>
  <button mat-flat-button color="primary" (click)="update()" cdkFocusInitial>
    <mat-icon>done</mat-icon>
    Update
  </button>
</div>
